import React from "react";
import DHSelectionComponent from "./DHSeclectionCompontent";
import {LIGAMODUS} from "./ligaModus";

export function LigaSpieltagModusComponent({id, disabled, onChange}) {
    return <DHSelectionComponent value={id} onChange={onChange} disabled={disabled} values={LIGAMODUS} title="Modus Ligaspieltag"/>
}
